/** Espelha `GET /v1/admin/usage`. */
export interface TenantUsageDto {
  tenant_id: string
  product: string | null
  ups_total: number
  ups_month: number
  ups_per_day: number
  /** 0 significa sem teto. */
  ups_per_month: number
  /** `active`, `inactive` ou `no-key` quando há consumo mas nenhuma chave viva. */
  status: string
}

export interface UsageListResponse {
  usage: TenantUsageDto[]
  total: number
}

/** Percentual da cota mensal consumido, ou null quando não há teto. */
export function monthlyQuotaPercent(usage: TenantUsageDto): number | null {
  if (!usage.ups_per_month || usage.ups_per_month <= 0) return null
  return Math.min(100, Math.round((usage.ups_month / usage.ups_per_month) * 100))
}
